import React from 'react';
import {CriticalIcon, LinkPanel, WarningIcon} from '@taopix/taopix-design-system';
import {MouseEventHandler} from 'react';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';

type FlightCheckIssueProps = {
  type: 'critical' | 'warning';
  issueTitle: string;
  issueDescription?: string;
  pageName: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const FlightCheckIssue = ({
  type,
  issueTitle,
  issueDescription,
  pageName,
  onClick,
}: FlightCheckIssueProps) => {
  const ui = useUiState();

  const icon = type === 'critical' ? <CriticalIcon /> : <WarningIcon />;

  return (
    <LinkPanel
      onClick={onClick}
      heading={issueTitle}
      icon={icon}
      helpMessage={issueDescription}
      helpTipDirection={ui.state.isSmallScreen ? 'left' : 'right'}
      closeTipOnScroll={true}
    >
      <p className={'italic underline ml-[30px]'}>{pageName}</p>
    </LinkPanel>
  );
};

export default FlightCheckIssue;
